import React, { useMemo } from "react";
import { If, Then } from "react-if";
import { FreemiumControllerService } from "@/api";
import useQuery from "@/hooks/useQuery";

export interface Props {
  isFreemiumTenant?: boolean;
  tenantId?: string;
}

const FreemiumDataBar: React.FC<Props> = ({ isFreemiumTenant, tenantId }) => {
  const { data: freemiumData } = useQuery({
    method: FreemiumControllerService.getLatestFreemiumDataUsingGet,
    params: {
      tenantId: tenantId as string,
    },
    options: {
      enabled: !!(isFreemiumTenant && tenantId),
    },
  });

  const isDataLimitExceeded = useMemo(
    // checking if currentDataSize is more than 90% of totalSizeThreshold
    () =>
      freemiumData?.totalSizeThreshold &&
      freemiumData.currentDataSize &&
      // (90 * freemiumData.totalSizeThreshold) / 100 <=
      freemiumData.totalSizeThreshold <= freemiumData.currentDataSize,
    [freemiumData],
  );

  if (freemiumData?.totalSizeThreshold) {
    return (
      <div className="freemium-data-bar-container">
        <If condition={isDataLimitExceeded}>
          <Then>
            <span className="k-icon k-font-icon k-i-warning-triangle" />
          </Then>
        </If>
        Data processed to date is
        <b>{freemiumData.currentDataSize} GB</b> of the{" "}
        <b>{freemiumData.totalSizeThreshold} GB.</b> Please upgrade to get
        unlimited data processing.
      </div>
    );
  }

  return null;
};

export default FreemiumDataBar;
